module.exports = __webpack_public_path__ + "img/RQ.2700bd42.svg";